export var CloudDeviceType;
(function (CloudDeviceType) {
    CloudDeviceType["Google"] = "google";
    CloudDeviceType["Garmin"] = "garmin";
    CloudDeviceType["Polar"] = "polar";
    CloudDeviceType["IHealth"] = "ihealth";
    CloudDeviceType["Withings"] = "withings";
    CloudDeviceType["Omron"] = "omron";
})(CloudDeviceType || (CloudDeviceType = {}));
export var BleDeviceType;
(function (BleDeviceType) {
    BleDeviceType["AccuChekInstant"] = "accu_check_inst";
    BleDeviceType["Aoj20aBt"] = "aoj_20a";
    BleDeviceType["AirBp2"] = "air_bp2";
    BleDeviceType["B02T"] = "b02t";
    BleDeviceType["LescaleF4"] = "lescale_f4";
    BleDeviceType["CheckmeO2Max"] = "check_o2_max";
    BleDeviceType["Oxyfit"] = "oxyfit";
    BleDeviceType["Bm1000B"] = "bm1000b";
    BleDeviceType["Sigmafon"] = "sigmafon";
})(BleDeviceType || (BleDeviceType = {}));
export var AppleDeviceType;
(function (AppleDeviceType) {
    AppleDeviceType["Apple"] = "apple";
})(AppleDeviceType || (AppleDeviceType = {}));
export var ManualDeviceType;
(function (ManualDeviceType) {
    ManualDeviceType["Manual"] = "manual";
})(ManualDeviceType || (ManualDeviceType = {}));
export var ProviderConnectionStatus;
(function (ProviderConnectionStatus) {
    ProviderConnectionStatus["Off"] = "off";
    ProviderConnectionStatus["Inactive"] = "inactive";
    ProviderConnectionStatus["Active"] = "active";
})(ProviderConnectionStatus || (ProviderConnectionStatus = {}));
const FOR_HUMANS = {
    [ProviderConnectionStatus.Off]: "–",
    [ProviderConnectionStatus.Inactive]: "Inactive",
    [ProviderConnectionStatus.Active]: "Active",
};
export const getConnectionStatusChoices = (selected) => Object.values(ProviderConnectionStatus).map((connectionStatus) => ({
    key: connectionStatus,
    text: FOR_HUMANS[connectionStatus],
    isSelected: !!(selected === null || selected === void 0 ? void 0 : selected.includes(connectionStatus)),
}));
export const connectionStatusForHumans = (value) => FOR_HUMANS[value];
